






























import textfield from '../form/Textfield.vue'
import password from '../form/Password.vue'

export default {
  name: 'Login'

  components:
    'v-textfield': textfield
    'v-password': password

  data: () ->
    username: null
    password: null
    error: false

  methods:
    onError: (errors) ->
      console.log errors
      @errors.clear()
      for error in errors
        @$validator.errorBag.add(error.field, error.msg, error.ruleName)

    login: () ->
      self = this
      await @$store.dispatch('login',
        username: self.username
        password: self.password
        )
      .catch (err) ->
        console.log 'Error i Login.vue'
        self.error = true
        self.username = null
        self.password = null
        setTimeout () ->
          self.error = false
        , 3000
      @$router.push '/start'

}




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Login.vue